import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '../context/auth-context';

/**
 * Hook for consuming the auth context.
 * Must be used within an AuthProvider — throws if used outside.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
